import script from "./DeleteConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./DeleteConfirmation.vue?vue&type=style&index=0&id=c01eac94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c01eac94"]])

export default __exports__